import React from "react";
import { Modal } from "react-bootstrap";
import "./DocumentosPacienteModal.css";

/**
 * Modal estándar para documentos del paciente (fórmulas, incapacidades, etc.).
 * En móvil: pantalla completa, safe-area y z-index por encima del navbar.
 */
function DocumentoPacienteModal({
    show,
    onHide,
    title,
    children,
    size = "xl",
    enforceFocus,
    restoreFocus,
}) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            scrollable
            fullscreen="md-down"
            enforceFocus={enforceFocus}
            restoreFocus={restoreFocus}
            className="modal-documentos-paciente-root"
            dialogClassName="modal-documentos-paciente"
        >
            <Modal.Header closeButton className="documentos-modal-header py-2">
                <Modal.Title className="mb-0 h5 documentos-modal-title">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="documentos-modal-body pt-2">
                {children}
            </Modal.Body>
        </Modal>
    );
}

export default DocumentoPacienteModal;
